import { EditorReadyOptions, EditorSDK } from '@wix/platform-editor-sdk';
import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';

export const ERROR_MESSAGES = {
  INVITE_CODE_NOT_FOUND: 'Invite code not found.',
} as const;

/*
Detect Editor
*/
export const isEditor = (flowApi: PlatformControllerFlowAPI) =>
  !flowApi.environment.isViewer;

export const isMobileViewport = async (editorSDK: EditorSDK) => {
  const editorMode = await editorSDK.info.getCurrentViewport();
  return editorMode.type === 'MOBILE';
};
export const getPrefixApi = (flowApi: PlatformControllerFlowAPI) => {
  const api = isEditor(flowApi) ? '' : '/_api';
  return api;
};
export const getIsStudio = (context: EditorReadyOptions) => {
  return context.origin?.subType === 'STUDIO';
};

export const buildAuthHeaders = (flowApi: PlatformControllerFlowAPI) => {
  return flowApi.controllerConfig
    ? {
        headers: {
          Authorization: flowApi.controllerConfig.appParams.instance,
        },
      }
    : {};
};

export const getCommonErrorCodesMap = (t: (key: string) => string) => ({
  applicationError: {
    INVALID_INSTANCE: () => ({
      message: "Invalid app instance provided.",
    }),
    UNAUTHORIZED: () => ({
      message: "You are not authorized to access this resource.",
    }),
    NOT_FOUND: () => ({
      message: ERROR_MESSAGES.INVITE_CODE_NOT_FOUND,
    }),
  },
  serverError: () => ({
    message: t('download_my_app.widget.serverError'),
  }),
});

export const handleApiError = <T>(error: any, getResolvedError: (error: any) => any, context: string, fallbackData: T): T => {
  const resolvedError = getResolvedError(error);
  console.error(`Error fetching ${context}:`, resolvedError);
  return fallbackData;
};
